import { Model } from "services/models/model";
import { IModel } from "./../IModel";
import { ObjectMapper } from "json-object-mapper";
import { ExcusedAbsenceStatusType } from "services/enums/ExcusedAbsenceStatusType.enum";
import { isValidDate } from "utils/helps";
import moment from "moment-business-days";

export class ExcusedAbsenceModel
  extends Model
  implements IModel<ExcusedAbsenceModel> {
  companyGroupId: string | undefined = undefined;
  companyId: string | undefined = undefined;
  employeeId: string | undefined = undefined;
  timeOccurrenceId: string | undefined = undefined;
  dateBegin: string = "";
  dateEnd: string = "";
  hourBegin: string = null;
  hourEnd: string = null;
  amountDays: number = 0;
  issuerName: string = "";
  issuerUF: string = "";
  issuerCRM: string = "";
  issuerNumber: string = "";
  sequential: number = 0;
  sequentialReference: number = 0;

  absenceTypeId: string | undefined = undefined;
  absenceTypeDescription: string = "";
  workLeaveTypeId: string | undefined = undefined;
  workLeaveTypeDescription: string = "";
  icdClassificationId: string | undefined = undefined;
  icdClassificationDescription: string = "";
  status: any = ExcusedAbsenceStatusType.Pending.value;
  fileKey: string = "";
  fileName: string = "";
  integrate: boolean = false;
  qualificationType: string = "0"; // Default to LegalAbsence
  bonusReasonId: string | undefined = undefined;
  bonusReasonDescription: string = "";
  reproveReason: string = "";

  get statusBadge(): string {
    const status = ExcusedAbsenceStatusType.getBy(this.status);
  
    return `<span class="badge badge-pill badge-light-${status.className} rounded-pill text-wrap">${status.label}</span>`;
  }

  static create(input: any): ExcusedAbsenceModel {
    return ObjectMapper.deserialize<ExcusedAbsenceModel>(
      ExcusedAbsenceModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  public formatDates() {
    if (!isValidDate(this.dateBegin)) {
      const dateBeginValid = moment(this.dateBegin).format('yyyy-MM-DD').toString();
      this.dateBegin = dateBeginValid != 'Invalid date' ? dateBeginValid : this.dateBegin;
    }
    if (!isValidDate(this.dateEnd)) {
      const dateEndValid = moment(this.dateEnd).format('yyyy-MM-DD').toString();
      this.dateEnd = dateEndValid != 'Invalid date' ? dateEndValid : this.dateEnd;
    }
  }
}
